export const NOTIFICATION_PER_PAGE = 20;
